import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import React, { SyntheticEvent } from 'react';

interface SelectComponentProps {
    onChange: (value: string) => void;
    value: string;
    label: string;
    options: {text: string, value: string}[];
    autoComplete?: boolean;
    disabled?: boolean;
}

const PREFIX = 'SelectComponent';

const classes = {
    selectField: `${PREFIX}-selectField`,
};

const StyledBox = styled(Box)((
    {
        theme: any,
    },
) => ({
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--color-foreground)!important',
    },
    '& .MuiFormLabel-root': {
        color: 'var(--color-foreground)!important',
    },
    '& .MuiInputBase-input': {
        color: 'var(--color-foreground)!important',
    },
    '& .MuiOutlinedInput-root': {
        '& textarea': {
            overflow: 'hidden',
        },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--color-foreground)!important',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'var(--color-foreground)!important',
    },
    '& .MuiSvgIcon-root': {
        color: 'var(--color-foreground)!important',
    },
    '& .MuiOutlinedInput-input': {
        color: 'var(--color-foreground)!important',
        '-webkit-text-fill-color': 'var(--color-foreground)!important',
    },
}));

export default function SelectComponent(props: SelectComponentProps) {

    const handleChange = (event: SelectChangeEvent) => {
        props.onChange(event.target.value as string);
    };

    const handleAutoCompleteChange = (
        _: SyntheticEvent<Element, Event>,
        value: {text: string, value: string} | null,
    ) => {
        props.onChange(value?.value ?? '');
    };

    return (
        <StyledBox sx={{ minWidth: 120 }}>
            <FormControl fullWidth={true} disabled={!!props.disabled}>
                {!props.autoComplete
                    ? (
                        <React.Fragment>

                            <InputLabel id={'demo-simple-select-label'}>{props.label}</InputLabel>
                            <Select
                                labelId={'demo-simple-select-label'}
                                id={'demo-simple-select'}
                                value={props.value}
                                label={props.label}
                                onChange={handleChange}
                                MenuProps={{ classes: { paper: classes.selectField } }}
                            >
                                {props.options.map((option) =>
                                    <MenuItem value={option.value}>{option.text}</MenuItem>)}
                            </Select>
                        </React.Fragment>

                    ) : (
                        <Autocomplete
                            disablePortal={true}
                            disabled={!!props.disabled}
                            getOptionLabel={(option) => option.text}
                            getOptionKey={(option) => option.value}
                            options={props.options}
                            renderInput={(params) =>
                                <TextField {...params} label={props.label} />}
                            onChange={handleAutoCompleteChange}
                        />
                    )}
            </FormControl>
        </StyledBox>
    );
}
